import gql from 'graphql-tag';
import HelperGraphql from "utils/helper-graphql";
import FieldsRoom from 'graphql/fields/FieldsRoom'

const fields = {
	'guid': 'String',
	'floor_guid': 'String!',
	'name': 'String!',
	'capacity': 'Int',
	'position': 'Int',
	'kind': 'String',
	'available_for': 'String',
	'aed': 'String',
	'active': 'String!',
};

export default gql(`
	mutation room( ${ HelperGraphql.createFields( fields ) } ) {
	    room( ${ HelperGraphql.createVariables( fields ) } ) {
	       ${FieldsRoom}
	       
	       floor {
	            guid
	       }
	    }
	}
`);

